import { render, staticRenderFns } from "./CustomDetailsV2.vue?vue&type=template&id=9b532978&scoped=true"
import script from "./CustomDetailsV2.vue?vue&type=script&lang=js"
export * from "./CustomDetailsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b532978",
  null
  
)

export default component.exports